import { picUserImageUrl } from '@/common/utils/picUserImageUrl';
import type { JabazDoctor } from '../types';

/** The profile's doctor, as the Jabaz screens show it (name, photo, expertise, next release). */
export const buildJabazDoctor = ({
  slug,
  doctor,
  expertises,
  userId,
  releaseAt,
}: {
  slug: string;
  doctor: any;
  expertises: any;
  centers?: any[];
  userId?: string | number | null;
  releaseAt?: string | null;
}): JabazDoctor => ({
  slug: decodeSlug(slug),
  name: doctor?.display_name ?? '',
  expertise: expertises?.expertises?.[0]?.alias_title || expertises?.group_expertises?.[0]?.name || undefined,
  avatar: userId != null && userId !== '' ? picUserImageUrl(userId) : undefined,
  userId: userId != null && userId !== '' ? String(userId) : undefined,
  releaseAt: releaseAt ?? null,
});

const decodeSlug = (slug: string) => {
  try {
    return decodeURIComponent(slug);
  } catch {
    return slug;
  }
};
